class ScrollingIndicator {
  public items: HTMLCollection;

  bindings() {
    if (this.items) {
      Object.values(this.items).forEach((item: any) => {
        const container = item.parentElement.parentElement;
        container.onscroll = function() {
          let winScroll = container.scrollTop;
          let height = container.scrollHeight - document.documentElement.clientHeight;
          let scrolled = (winScroll / height) * 100;
          item.style.height = scrolled + "%";
        };
      });
    }
  }

  cache() {
    this.items = document.getElementsByClassName('js-scrolling-indicator');
  }

  init() {
    this.cache();
    this.bindings();
  }
}

export default ScrollingIndicator;
